// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertNameEdit-module__container__1QSXh","body-text":"AlertNameEdit-module__body-text__1dndt","buttons":"AlertNameEdit-module__buttons__VO41z"};